import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import globalStore from 'src/utils/global-data-store';
import Stars from './stars';
import './index.scss';

export default class CompanyCard extends Component {
  static propTypes = {
    seller: PropTypes.object,
    productId: PropTypes.number,
  };

  constructor(props) {
    super(props);
    this.state = {
      supplierData: null,
    };
  }

  componentDidMount() {
    const { productId } = this.props;
    if (!productId) return;

    const fetchPromise = globalStore.get('supplierData');

    if (fetchPromise) {
      fetchPromise.then(data => {
        if (!data || !data.isSuccess || !data.result) {
          return;
        }
        if (
          data.result.supplierOnTimeDeliveryRate &&
          data.result.supplierOnTimeDeliveryRate !== '0.0%'
        ) {
          this.setState({
            ...this.state,
            supplierData: {
              ...this.state.supplierData,
              supplierOnTimeDeliveryRate:
                data.result.supplierOnTimeDeliveryRate,
            },
          });
        }

        if (data.result.supplierOnCredit) {
          this.setState({
            ...this.state,
            supplierData: {
              ...this.state.supplierData,
              supplierOnCredit: data.result.supplierOnCredit,
            },
          });
        }

        this.setState({
          ...this.state,
          supplierData: {
            ...this.state.supplierData,
            stars: data.result.supplierStars,
          },
        });
      });
    }
  }

  render() {
    const { props } = this;
    const { i18n = {} } = props;
    const {
      // 付费用户即会员gs
      accountIsPaidMember,
      // 信保亮灯
      baoAccountIsDisplayAssurance,
      // 是gps用户即金品认证用户
      accountIsGoldPlusSupplier,
      // i18n = {
      //   ...I18n[props.language || 'en_US']
      // },
      companyName,
      homeUrl,
      companyBusinessType,
      companyRegisterCountry,
      companyJoinYears,
      companyId,
      feedbackUrl,
      supplierRatingReviews,
      supplierRating,
      isShowFeedbackBuyerNum,
      sesameFirstReplyRate,
      tradeHistoryUrl,
      tradeIsView,
      isShowComplaintsInfo,
      sesameSolvedComplaintNum,
      sesameUnsolvedComplaintNum,
      tradeHalfYear,
      responseTimeText,
      overseaBrand,
      transactionLevelUrl,
      isCompanyBusinessTypeAuth,
    } = props.seller;

    const isGS = accountIsPaidMember && !accountIsGoldPlusSupplier;
    const isGPS = accountIsPaidMember && accountIsGoldPlusSupplier;
    const isIFM = !accountIsPaidMember;
    const cls = classnames(
      'scc-wrapper',
      'detail-module',
      'module-companyCardIntegrated',
      'module-companyCardIntegrated-lite',
      'module-companyCardIntegrated-lite-b',
    );
    const cls1 = classnames(
      'widget-supplier-card',
      'company-card-integrated',
      'company-card-integrated-lite',
      {
        'has-ta': baoAccountIsDisplayAssurance,
        'oversea-background': overseaBrand,
        'gs-background': isGS && !overseaBrand,
        'gps-background': isGPS && !overseaBrand,
        'ifm-background': isIFM,
      },
    );
    const { supplierData } = this.state;

    return (
      <div className={cls} data-spm="cordpanyb" style={{ width: 260 }}>
        <div
          className={cls1}
          data-role="widget-supplier-card"
          data-aui="supplier-card"
        >
          <div className="card-central-logo">
            {isGS && (
              <a
                href="//fuwu.alibaba.com/gps/buyer.htm?tracelog=from_widget_supplier_card_esite"
                target="_blank"
                data-aui="ta-ordered"
                rel="nofollow"
                title={i18n['widget.supplierCard.gs']}
              >
                <i className="svg-card-icon svg-card-icon-gs" />
                <span>Gold Supplier</span>
              </a>
            )}
            {isGPS && (
              <a
                href="//fuwu.alibaba.com/page/verifiedsuppliers.htm?tracelog=from_widget_supplier_card_plus_esite"
                target="_blank"
                data-aui="ta-ordered"
                rel="nofollow"
              >
                <img
                  src="//img.alicdn.com/tfs/TB1z2BEFND1gK0jSZFsXXbldVXa-42-10.svg"
                  style={{ height: '11px' }}
                  className="card-icon card-icon-img card-icon-wide card-icon-gps"
                />{' '}
                <span>Supplier</span>
              </a>
            )}
          </div>
          {/* 公司头像、公司名称链接 */}
          <div className="company-name-container">
            <a
              className="company-name company-name-lite-vb"
              href={homeUrl}
              target="_blank"
              title={companyName}
              data-aui="company-name"
              data-domdot="id:3317"
            >
              {companyName}
            </a>
          </div>
          {/* 公司年限、国家、供应商类型 */}
          {companyBusinessType && isCompanyBusinessTypeAuth && (
            <div className="business-type-lite">
              {overseaBrand && (
                <img
                  src="https://img.alicdn.com/imgextra/i4/O1CN01350gqJ1cjKkuKUxqc_!!6000000003636-2-tps-76-26.png"
                  height="14px"
                />
              )}
              {companyBusinessType}
            </div>
          )}
          <div className="card-supplier card-icons-lite">
            {companyRegisterCountry && (
              <span className="company-name-country">
                <i
                  className={`icbu-icon-flag icbu-icon-flag-${String(
                    companyRegisterCountry,
                  ).toLowerCase()}`}
                />
                <span className="register-country">
                  {companyRegisterCountry}
                </span>
              </span>
            )}
            {(isGS || isGPS) && (
              <a className="verify-info" data-aui="ggs-icon" rel="nofollow">
                <span className="join-year">
                  <span className="value">
                    &nbsp;&nbsp;&nbsp;{companyJoinYears}
                  </span>
                  <span className="unit">
                    {companyJoinYears == 1 ? 'YR' : 'YRS'}
                  </span>
                </span>
              </a>
            )}
            {baoAccountIsDisplayAssurance && (
              <div className="icon-item">
                <a
                  data-role="ta-info"
                  href="//tradeassurance.alibaba.com/?tracelog=from_widget_supplier_card_esite"
                  target="_blank"
                  data-aui="ta-ordered"
                  rel="nofollow"
                  title={i18n['widget.supplierCard.ta']}
                >
                  <i className="svg-card-icon svg-card-icon-ta" />
                </a>
              </div>
            )}
            {this.state.supplierData && (
              <Stars
                stars={this.state.supplierData.stars}
                i18n={i18n}
                companyRegisterCountry={companyRegisterCountry}
                companyId={companyId}
              />
            )}
          </div>
          {/* 纠纷信息 */}
          {isShowComplaintsInfo &&
          sesameSolvedComplaintNum &&
          sesameSolvedComplaintNum > 0 &&
          sesameUnsolvedComplaintNum &&
          sesameUnsolvedComplaintNum > 0 &&
          sesameUnsolvedComplaintNum &&
          sesameUnsolvedComplaintNum > 0 ? (
            <div className="card-complains">
              <p>
                <i className="ui2-icon ui2-icon-warning" />
                {sesameUnsolvedComplaintNum} Unsolved Buyer Complaints
              </p>
            </div>
          ) : null}
          {/* 表格区 */}
          {
            <table
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                window.open(homeUrl);
              }}
            >
              <tbody>
                {!responseTimeText &&
                  isShowFeedbackBuyerNum &&
                  sesameFirstReplyRate &&
                  sesameFirstReplyRate !== '0%' && (
                    <tr className="card-info-item">
                      <th>
                        <i className="ui2-icon ui2-icon-skip util-left" />
                      </th>
                      <td>
                        <a
                          className="performance-value-wrap"
                          href={tradeHistoryUrl}
                          target="_blank"
                          data-domdot="id:3650,mn:esite"
                          data-aui="res-rate-value"
                          rel="nofollow"
                        >
                          <b className="util-left">{sesameFirstReplyRate}</b>
                        </a>
                        <a
                          href={tradeHistoryUrl}
                          target="_blank"
                          data-domdot="id:3650,mn:esite"
                          data-aui="res-rate-title"
                          rel="nofollow"
                        >
                          &nbsp;{i18n['widget.supplierCard.resRateTitle']}
                        </a>
                      </td>
                    </tr>
                  )}
                {responseTimeText && (
                  <tr className="card-info-item" id="transactionAmountTrigger">
                    <th>
                      <i className="ui2-icon ui2-icon-skip util-left" />
                    </th>
                    <td>
                      <a
                        className="performance-value-wrap"
                        href={tradeHistoryUrl}
                        target="_blank"
                        data-domdot="id:3650,mn:esite"
                        data-aui="res-rate-value"
                        rel="nofollow"
                      >
                        <b className="util-left">{responseTimeText}</b>
                      </a>
                      <a
                        href={tradeHistoryUrl}
                        target="_blank"
                        data-domdot="id:3650,mn:esite"
                        data-aui="res-rate-title"
                        rel="nofollow"
                      >
                        &nbsp;{i18n['widget.supplierCard.resTimeTitle']}
                        <div className="ui2-balloon ui2-balloon-tl ui2-shadow-normal transaction-section-tip">
                          {i18n['widget.supplierCard.resTimeTip']}
                        </div>
                      </a>
                    </td>
                  </tr>
                )}
                {tradeIsView &&
                  tradeHalfYear &&
                  tradeHalfYear.ordAmt &&
                  tradeHalfYear.ordCnt6m &&
                  tradeHalfYear.ordCnt6m > 0 && (
                    <tr
                      id="transactionAmountTrigger"
                      className="card-info-item"
                    >
                      <th>
                        <i className="ui2-icon ui2-icon-dollar" />
                      </th>
                      <td>
                        <span>
                          <b>{tradeHalfYear.ordAmt}</b>
                        </span>{' '}
                        {i18n['widget.supplierCard.transaction.for']}
                        <b> {tradeHalfYear.ordCnt6m}</b>{' '}
                        {i18n['widget.supplierCard.transactions']}
                        <div className="ui2-balloon ui2-balloon-tl ui2-shadow-normal transaction-section-tip">
                          {i18n['widget.supplierCard.transaction.tip']}
                        </div>
                      </td>
                    </tr>
                  )}
                {supplierData && supplierData.supplierOnTimeDeliveryRate ? (
                  <tr
                    className="card-info-item on-time-shippment"
                    data-role="onTimeShippment"
                  >
                    <th>
                      <i className="next-icon next-icon-on_time_shippment next-icon-xs " />
                    </th>
                    <td>
                      <span className="on-time-value">
                        <b className="util-left" data-role="onTimeShippmentVal">
                          {supplierData.supplierOnTimeDeliveryRate}
                        </b>
                      </span>
                      <span className="on-time-title">
                        {i18n['companyCardIntegrated.ontimeShipment']}
                      </span>
                      <div
                        className="ui2-balloon ui2-balloon-tl ui2-shadow-normal on-time-shippment-tip"
                        data-role="onTimeShippmentTip"
                      >
                        {(
                          i18n['companyCardIntegrated.deliveryTip'] || ''
                        ).replace(
                          '{0}',
                          supplierData.supplierOnTimeDeliveryRate,
                        )}
                      </div>
                    </td>
                  </tr>
                ) : null}
              </tbody>
            </table>
          }
        </div>
      </div>
    );
  }
}
